var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto",attrs:{"id":"app"}},[_c('notifications'),_vm._v(" "),(_vm.authState.isAuthenticated)?[_c('div',{staticClass:"clearfix"},[_c('b-button',{staticClass:"float-right",attrs:{"pill":"","variant":"outline-danger"},on:{"click":_vm.logout}},[_vm._v("\n        Logout\n      ")])],1)]:_vm._e(),_vm._v(" "),_c('router-view')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ae972d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 